/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Rut_OkInputs */

const en_mk_tut_rut_ok = /** @type {(inputs: Mk_Tut_Rut_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The routine card shows “Next: tomorrow 09:00”, and **Run now** proves it without waiting until tomorrow.`)
};

const id_mk_tut_rut_ok = /** @type {(inputs: Mk_Tut_Rut_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu rutinitas menampilkan "Berikutnya: besok 09.00", dan tombol **Jalankan sekarang** membuktikannya tanpa menunggu besok.`)
};

/**
* | output |
* | --- |
* | "The routine card shows “Next: tomorrow 09:00”, and **Run now** proves it without waiting until tomorrow." |
*
* @param {Mk_Tut_Rut_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_rut_ok = /** @type {((inputs?: Mk_Tut_Rut_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Rut_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_rut_ok(inputs)
	return en_mk_tut_rut_ok(inputs)
});